import { apiClient } from './api';

export interface ChatMessage {
  id: string;
  content: string;
  role: 'user' | 'assistant';
  timestamp: Date;
  sources?: Array<{
    title: string;
    content: string;
    url?: string;
  }>;
}

export interface ChatRequest {
  message: string;
  conversation_id?: string;
}

export interface ChatResponse {
  response: string;
  conversation_id?: string;
  message_id?: string;
  metadata?: any;
}

export interface SearchRequest {
  query: string;
  conversation_id?: string;
}

export interface SearchResponse {
  response: string;
  sources?: Array<{
    title: string;
    content: string;
    url?: string;
  }>;
  conversation_id: string;
  message_id: string;
}

class AIService {

  private generateId(): string {
    return Date.now().toString(36) + Math.random().toString(36).substr(2);
  }

  async sendChatMessage(request: ChatRequest): Promise<ChatResponse> {
    try {
      const response = await apiClient.post('/ai/chat', request);
      return response.data;
    } catch (error) {
      console.error('Error sending chat message:', error);
      throw new Error('Failed to send chat message');
    }
  }

  async sendSearchQuery(request: SearchRequest): Promise<SearchResponse> {
    try {
      const response = await apiClient.post('/ai/query/search', request);

      // Map the response to match expected interface
      const data = response.data;
      return {
        response: data.answer || data.response, // Handle both 'answer' and 'response' fields
        sources: data.sources || [],
        conversation_id: data.conversation_id || this.generateId(),
        message_id: data.message_id || this.generateId()
      };
    } catch (error) {
      console.error('Error sending search query:', error);
      throw new Error('Failed to send search query');
    }
  }

  async sendMessage(
    message: string,
    mode: 'rag' | 'non-rag',
    conversationId?: string
  ): Promise<ChatResponse | SearchResponse> {
    if (mode === 'rag') {
      return this.sendSearchQuery({
        query: message,
        conversation_id: conversationId,
      });
    } else {
      return this.sendChatMessage({
        message,
        conversation_id: conversationId,
      });
    }
  }
}

export const aiService = new AIService();